import { render } from "./banner_update.vue?vue&type=template&id=49a61c09"
import script from "./banner_update.vue?vue&type=script&lang=js"
export * from "./banner_update.vue?vue&type=script&lang=js"

import exportComponent from "D:\\svn\\esp-rms-xhjr-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__